import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateVerb } from '../../store/actions/wordAction'
import { Redirect } from 'react-router-dom'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FilledInput from '@material-ui/core/FilledInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Container from '@material-ui/core/Container';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

//import { Scrap } from './ScrapyCoco'
import Scrapper from './Scrapper'
import LanguageNames from '../shared/LanguageNames';

import { getFirestore } from 'redux-firestore';


function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};



export class EditVerb extends Component {
    state = {
        Language1: '',
        Language2: '',
        PresentParticiple: '',
        PastParticiple: '',
        set: '',
        sets: [{id:"3",name:"3"}],
        value:0,
        Present:[{}],
        Past:[{}],
        Past1:[{}],
        Conditional:[{}],
        Future:[{}],
        Imperativ:[{}],
        Imperativ1:[{}],
        Description1:'',
        Description2:''
      }



    componentWillMount(){
        this.fetchMainData(10,"verbs");
      }


      fetchMainData(limit,collection) { 

      let firestore = getFirestore();
      let temp_id = this.props.location.state.id;
       var temp_settings = firestore.collection("verbs").doc(temp_id);

       temp_settings.get().then(
         (doc) => {
           if (doc.exists) {
   //          console.log(doc.data());
              let data = doc.data();
            this.setState({
            //  settingSpeak:doc.data(),
              Language1: data.Language1,
              Language2: data.Language2,
              PresentParticiple: data.PresentParticiple,
              PastParticiple: data.PastParticiple,
              //set: '',
            //  sets: [{id:"3",name:"3"}],
             //value:0,
              Present:data.Present,
              Past:data.Past,
              Past1:data.Past1,
              Conditional:data.Conditional,
              Future:data.Future,
              Imperativ:data.Imperativ,
              Imperativ1:data.Imperativ1,
              Description1:data.Description1,
              Description2:data.Description2,
            });
             console.log(this.state.settingSpeak);
           } else {
           }
 
       }).catch(function(error) {
           console.log("Error getting document:", error);
       });
      }  



componentWillReceiveProps(nextProps) {
  //  alert("asas");
// this.setState({ 
//     sets: nextProps.sets
// });
}

handleChange=(e,name,id)=>{
// alert(e.target.value);
      if(name=="Past")
      {
    //    let index = this.state.words.findIndex(e=>e.id==id)
        let NewPast = this.state.Past;
        NewPast[id]=e.target.value;
        this.setState({
          Past: NewPast
        })
      }
      else if(name=="Past1")
      {
        let NewPast = this.state.Past1;
        NewPast[id]=e.target.value;
        this.setState({
          Past1: NewPast
        })
      }
      else if(name=="Present")
      {
        let TempArray = this.state.Present;
        TempArray[id]=e.target.value;
        this.setState({
          Present: TempArray
        })
      }
      else if(name=="Conditional")
      {
        let TempArray = this.state.Conditional;
        TempArray[id]=e.target.value;
        this.setState({
          Conditional: TempArray
        })
      }
      else if(name=="Future")
      {
        let TempArray = this.state.Future;
        TempArray[id]=e.target.value;
        this.setState({
          Future: TempArray
        })
      }
      else if(name=="Imperativ")
      {
        let TempArray = this.state.Imperativ;
        TempArray[id]=e.target.value;
        this.setState({
          Imperativ: TempArray
        })
      }
      else if(name=="Imperativ1")
      {
        let TempArray = this.state.Imperativ1;
        TempArray[id]=e.target.value;
        this.setState({
          Imperativ1: TempArray
        })
      }
      else
      {
        this.setState({
          [e.target.id]: e.target.value
        })
      }
      // console.log(e);
       console.log(this.state.Past);
}
handleSubmit = (e) => {
    e.preventDefault();
    // console.log(this.state);

    delete this.state.sets;
    delete this.state.value;
    this.setState(this.state);

    this.props.updateVerb(this.state,this.props.location.state.id);
    this.props.history.push('/card');
  }

   handleChangeSelect=(event)=> {
       console.log(event);
       this.setState({ 
        set: event.target.value
    });

  }

   handleChangeTable=(event, newValue)=> {
   // setValue(newValue);
   this.setState({ 
    value: newValue
});
  }

  handleChangeIndex=(index)=> {
 //   setValue(index);
  }



ScrapperCall=(Language2,PresentParticiple,PastParticiple,Present,Past,Past1,Conditional,Future,Imperativ,Imperativ1)=> {
  this.setState({
    Language2:Language2, 
    PresentParticiple:PresentParticiple,
    PastParticiple:PastParticiple,
    Present:Present,
    Past:Past,
    Past1:Past1,
    Conditional:Conditional,
    Future:Future,
    Imperativ:Imperativ,
    Imperativ1:Imperativ1
 
});
}



 handleLanguageChange=(name)=> {
  this.setState({
    set: name
    });
 
  }

    render() {
 


        return (
                    <Container maxWidth="xl">
            <Paper className="paper-container">
         
            <div className="container">
                    <form className="white" onSubmit={this.handleSubmit}>
                    <h5 className="grey-text text-darken-3">Crear una nueva oración</h5>
 
                    


                    <Tabs
        value={this.state.value}
        onChange={this.handleChangeTable}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab label="General" />
        <Tab label="Present" />
        <Tab label="Past" />
        <Tab label="Past1" />
        <Tab label="Conditional" />
        <Tab label="Future" />
        <Tab label="Imperativ" />
      </Tabs>
      {this.state.value === 0 && <TabContainer>

        <p>General</p>
        
        {/* <Button onClick={this.ScrapyAsync1} variant="contained" color="secondary">
                        Scrap
                        </Button> */}
        <Scrapper ScrapperCall={this.ScrapperCall} SearchedWord={this.state.Language1}></Scrapper>

 


                        <Grid container spacing={3}>
                      <Grid item xs={4}>
                      <TextField sizeLarge 
                        id="Language1"
                        label="Language1"
                        className="Language1"
                        value={this.state.Language1}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <TextField sizeLarge 
                        id="Language2"
                        label="Language2"
                        className="Language2"
                        value={this.state.Language2}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <TextField sizeLarge 
                        id="PresentParticiple"
                        label="PresentParticiple"
                        className="PresentParticiple"
                        value={this.state.PresentParticiple}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <TextField sizeLarge 
                        id="PastParticiple"
                        label="PastParticiple"
                        className="PastParticiple"
                        value={this.state.PastParticiple}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>

                          </Grid>
                        <Grid item xs={8}>
     
                        <TextField fullWidth 
                        id="Description1"
                        label="Description1"
                        value={this.state.Description1}
                        onChange={this.handleChange}
                        margin="dense"
                        />

                        <TextField fullWidth 
                        id="Description2"
                        label="Description2"
                        value={this.state.Description2}
                        onChange={this.handleChange}
                        margin="dense"
                        />

                        </Grid>
                      </Grid>




        
        
        
        
        
        </TabContainer>}
      {this.state.value === 1 && <TabContainer>
      <p>Present</p>
        
      {
                    [...Array(6)].map((x, i) =>
                    (
                      <div>
                      <TextField sizeLarge 
                        id={"Present:"+i}
                        label={"Present:"+i}
                        value={this.state.Present[i]}
                        onChange={(e)=>this.handleChange(e,"Present",i)}
                        margin="dense"
                        />
                       <br></br>
                       </div>
                    )

              )
          }


      </TabContainer>}
      {this.state.value === 2 && <TabContainer>
        <p>Past</p>
        
        {
                      [...Array(6)].map((x, i) =>
                      (
                        <div>
                        <TextField sizeLarge 
                          id={"Past:"+i}
                          label={"Past:"+i}
                          value={this.state.Past[i]}
                          onChange={(e)=>this.handleChange(e,"Past",i)}
                          margin="dense"
                          />
                         <br></br>
                         </div>
                      )
  
                )
            }     

        </TabContainer>}
      {this.state.value === 3 && <TabContainer>
        <p>Past1</p>
        
        {
                      [...Array(6)].map((x, i) =>
                      (
                        <div>
                        <TextField sizeLarge 
                          id={"Past1:"+i}
                          label={"Past1:"+i}
                          value={this.state.Past1[i]}
                          onChange={(e)=>this.handleChange(e,"Past1",i)}
                          margin="dense"
                          />
                         <br></br>
                         </div>
                      )
  
                )
            }   
        
        </TabContainer>}

        {this.state.value === 4 && <TabContainer>
        <p>Conditional</p>
        
        {
                      [...Array(6)].map((x, i) =>
                      (
                        <div>
                        <TextField sizeLarge 
                          id={"Conditional:"+i}
                          label={"Conditional:"+i}
                          value={this.state.Conditional[i]}
                          onChange={(e)=>this.handleChange(e,"Conditional",i)}
                          margin="dense"
                          />
                         <br></br>
                         </div>
                      )
  
                )
            }   
        </TabContainer>}

      {this.state.value === 5 && <TabContainer>
        <p>Future</p>
        
        {
                      [...Array(6)].map((x, i) =>
                      (
                        <div>
                        <TextField sizeLarge 
                          id={"Future:"+i}
                          label={"Future:"+i}
                          value={this.state.Future[i]}
                          onChange={(e)=>this.handleChange(e,"Future",i)}
                          margin="dense"
                          />
                         <br></br>
                         </div>
                      )
  
                )
            }   
        </TabContainer>}
        {this.state.value === 6 && <TabContainer>
        <p>Imperativ</p>
        


        <Grid container spacing={3}>
        <Grid item xs={6}>
          {
                      [...Array(6)].map((x, i) =>
                      (
                        <div>
                        <TextField sizeLarge 
                          id={"Imperativ:"+i}
                          label={"Imperativ:"+i}
                          value={this.state.Imperativ[i]}
                          onChange={(e)=>this.handleChange(e,"Imperativ",i)}
                          margin="dense"
                          />
                         <br></br>
                         </div>
                      )
  
                )
            } 
            </Grid>
          <Grid item xs={6}>
          {
                      [...Array(6)].map((x, i) =>
                      (
                        <div>
                        <TextField sizeLarge 
                          id={"Imperativ1:"+i}
                          label={"Imperativ1:"+i}
                          value={this.state.Imperativ1[i]}
                          onChange={(e)=>this.handleChange(e,"Imperativ1",i)}
                          margin="dense"
                          />
                         <br></br>
                         </div>
                      )
  
                )
            } 
          </Grid>
        </Grid>



  
        </TabContainer>}

                        <br></br>
                    
                        <LanguageNames handleLanguageChange={this.handleLanguageChange}></LanguageNames>

                     <br></br>
                     <br></br>


                        <Button type="submit" value="Submit" variant="contained" color="secondary">
                        Save
                        </Button>


                    </form>
                </div>
                </Paper>
                </Container>
        )
    }
}


const mapStateToProps = (state) => {
  //  console.log(state.firestore);
   //console.log(this.state.words);
   return {
     sets:  state.firestore.ordered.sets
   }
 
 }

const mapDispatchToProps = dispatch => {
    return {
      updateVerb: (verb,id) => dispatch(updateVerb(verb,id))
    }
  }
  


  export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect([
       {
        collection: 'sets'
       }
    ])
  )(EditVerb)




//rafc
//rce